import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { decorators } from "@orange-marmalade/paginate-this";

import {
  ALTERNATES,
  EXACT,
  FULLY_INTERCHANGEABLE,
  REPLACES,
  REPLACED_BY,
  MODIFICATION,
  PMA,
  ANOMALY,
  MODEL_NUMBER,
  NATIONAL_STOCK_NUMBER,
  UNKNOWN,
  OEM
} from "MODULES/parts/constants";

import { groupBy } from "LIB/arrays";
import Alternate from "./Alternate";

function renderHeader(alternateType) {
  return (
    <tr>
      <th style={{ textAlign: "left" }}>{ALTERNATES[alternateType].label}</th>
    </tr>
  );
}

export function renderGroup(records, part) {
  return (
    <tr>
      <td width="100%">
        {records.map(r => <Alternate alternate={r} key={r.id} part={part} />)}
      </td>
    </tr>
  );
}

export function Table({ results, part }) {
  if (!results.length) {
    return false;
  }

  const groups = groupBy(results, "alternate_type");
  const header = name => groups[name] && renderHeader(name);
  const group = name => groups[name] && renderGroup(groups[name], part);

  return (
    <table className="table table-condensed">
      <tbody>
        {header(EXACT)}
        {group(EXACT)}
        {header(FULLY_INTERCHANGEABLE)}
        {group(FULLY_INTERCHANGEABLE)}
        {header(REPLACES)}
        {group(REPLACES)}
        {header(REPLACED_BY)}
        {group(REPLACED_BY)}
        {header(MODIFICATION)}
        {group(MODIFICATION)}
        {header(MODEL_NUMBER)}
        {group(MODEL_NUMBER)}
        {header(PMA)}
        {group(PMA)}
        {header(ANOMALY)}
        {group(ANOMALY)}
        {header(NATIONAL_STOCK_NUMBER)}
        {group(NATIONAL_STOCK_NUMBER)}
        {header(OEM)}
        {group(OEM)}
        {header(UNKNOWN)}
        {group(UNKNOWN)}
      </tbody>
    </table>
  );
}

Table.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  part: PropTypes.shape({})
};

const Decorated = decorators.tabulate(
  connect(state => ({
    part: state.partDetail.toJS().part
  }))(Table)
);

export default () => <Decorated listId="part/alternates" />;



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/Table.jsx